import type { SVGProps } from 'react';
const SvgRulerTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="m5 5.942 3.487 3.487-1.53 1.53A1 1 0 0 0 8.37 12.37l1.53-1.53 1.92 1.922-.528.529a1 1 0 0 0 1.412 1.412l.53-.529 1.92 1.92-1.53 1.53a1 1 0 0 0 1.412 1.413l1.53-1.53 3.487 3.488H4.996V5.938zm.275-2.55A1.33 1.33 0 0 0 3 4.334v17.333C3 22.404 3.596 23 4.333 23h17.332a1.338 1.338 0 0 0 .945-2.28zm3.4 10.942a.2.2 0 0 0-.342.141v2.858c0 .184.15.334.333.334h2.858a.2.2 0 0 0 .142-.342z"
    />
  </svg>
);
export default SvgRulerTriangle;
